import { IUser } from '@giphy/js-types'
import Header from 'modules/header/components/header'
import React, { Suspense, useRef } from 'react'
import { Provider } from 'react-redux'
import { Route, Switch } from 'react-router'
import { BrowserRouter } from 'react-router-dom'
import entryPoint from 'shared/components/entry-point-hoc'
import GDBootstrapper from 'shared/components/gd-bootstrapper'
import MarketingLandingPage from 'shared/components/giphy-marketers'
import GTALogger from 'shared/components/gta-logger'
import { getDefaultStore } from 'shared/redux/init-store'
import routes from 'shared/routes'
import AppsLandingRoute from './apps-landing/components/route'
import ArtistsRoute from './artists/route'
import Channel from './channel/components/app'
import ContextManagers from 'shared/context-managers'
import CurationRoute from './curation-station/route'
import Error404 from './error-pages/404'
import FilmFestDetail from './film-fest-detail'
import FilmFest from './film-fest/route'
import GifDetailRoute from './gif-detail/components/route'
import Homebase from './homebase/route'
import HomepageBeta from './homepage-beta/route'
import SiteContainer from './site-container'
import ChannelStoriesRoute from './stories/route'
import StoryRoute from './story/components/route'
import TeamPage from './team/team'
import TrendingRoute from './trending/route'
import Apply from './user/apply'
import Join from './user/join'
import Login from './user/login'
import Settings from './user/settings'
import VideosRoute, { VideoDetailRoute } from './videos/route'

const store = getDefaultStore({})

type Props = {
    id: string | number
    pageData: any
    showSearch?: boolean
    showBrowse?: boolean
    searchTerm?: boolean
    user?: IUser
    contextId?: string
}

const App = (props: any) => {
    const { pageData = {}, user, showSearch, showBrowse, searchTerm, contextId }: Props = props

    const is404 = useRef(pageData.status_code === 404)
    // if we have is404 in the template on first render
    if (is404.current) {
        // then the current pathname is a 404
        routes.ERROR_404.path = location.pathname
    }
    // page load context id for channel pages choosing, root, branch or leaf
    const channelType = useRef(contextId)
    if (channelType.current) {
        // there's no SPA but we're close...
        // we'd handle it with location state with an id when we history.push
        routes.CHANNEL.path = location.pathname
    }

    return (
        <Provider store={store}>
            <SiteContainer>
                <Suspense fallback={null}>
                    <BrowserRouter>
                        <GDBootstrapper initData={pageData}>
                            <ContextManagers>
                                {!pageData.hideHeader && <Header {...{ user, showSearch, showBrowse, searchTerm }} />}
                                <GTALogger />
                                <Switch>
                                    <Route {...routes.CHANNEL} render={() => <Channel {...props} />} />
                                    <Route {...routes.ERROR_404} exact component={Error404} />
                                    <Route {...routes.APPLY} component={Apply} />
                                    <Route {...routes.JOIN} component={Join} />
                                    <Route {...routes.MARKETERS} exact component={MarketingLandingPage} />
                                    <Route {...routes.LOGIN} component={Login} />
                                    <Route {...routes.CHANNEL_STORIES} component={ChannelStoriesRoute} />
                                    <Route {...routes.ARTISTS} component={ArtistsRoute} />
                                    <Route {...routes.STORY} component={StoryRoute} />
                                    <Route {...routes.GIF_DETAIL} component={GifDetailRoute} />
                                    <Route {...routes.VIDEOS} component={VideosRoute} />
                                    <Route {...routes.TRENDING_VIDEOS} component={VideosRoute} />
                                    <Route {...routes.FILM_FEST_DETAIL} component={FilmFestDetail} />
                                    <Route {...routes.VIDEO_DETAIL} component={VideoDetailRoute} />
                                    <Route {...routes.FILM_FEST} component={FilmFest} />
                                    <Route {...routes.TRENDING} component={TrendingRoute} />
                                    <Route {...routes.APPS} component={AppsLandingRoute} />
                                    <Route {...routes.SETTINGS} component={Settings} />
                                    <Route {...routes.HOMEBASE} component={Homebase} />
                                    <Route {...routes.EDIT_GIFS} component={CurationRoute} />
                                    <Route {...routes.TEAM} component={TeamPage} />
                                    <Route {...routes.HOME} component={HomepageBeta} />
                                    <Route exact component={Error404} />
                                </Switch>
                            </ContextManagers>
                        </GDBootstrapper>
                    </BrowserRouter>
                </Suspense>
            </SiteContainer>
        </Provider>
    )
}

export default entryPoint(store)(App)
